import { render } from "./SBtnBack.vue?vue&type=template&id=0d805647&ts=true"
import script from "./SBtnBack.vue?vue&type=script&lang=ts"
export * from "./SBtnBack.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__